import React from "react";
import ReportCTA from "../../../Common/ReportCTA";
import "../LowDataState/low_data_state.scss";
import "./DemandTeaser.scss";

const messageOf = (ownerView, hasProperties) => {
  if (hasProperties == null) return "\u00a0";
  if (ownerView) {
    return hasProperties
      ? "Select your home to see which want-listings match it."
      : "Add your home to see which want-listings match it.";
  }
  return hasProperties
    ? "Select a property to see its demand insights."
    : "Add a property to see the buyers who want a home like it.";
};

const DemandTeaser = ({ ownerView, hasProperties }) => (
  <div className="demand-teaser">
    <h6>Demand insights</h6>
    <div className="low-data-state low-data-state--notice">
      <div className="low-data-state__icon">
        <svg width="20" height="20" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path d="M16 10V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="16" cy="22" r="1" fill="currentColor" />
        </svg>
      </div>
      <p className="low-data-state__message">{messageOf(ownerView, hasProperties)}</p>
    </div>
    {ownerView ? null : <ReportCTA totalMatches={0} />}
  </div>
);

export default DemandTeaser;
